/** Labs / Studio app URL — dashboard lives at `/home`. */
export function getStudioAppUrl(): string {
  const raw = import.meta.env.VITE_STUDIO_URL;
  if (raw) return raw.replace(/\/$/, '');
  if (import.meta.env.DEV) return 'http://localhost:5173';
  return 'https://studio.aifluens.com';
}

/** Labs / Studio API origin — builder portfolio and profile endpoints. */
export function getStudioApiUrl(): string {
  const raw = import.meta.env.VITE_STUDIO_API_URL;
  if (raw) return raw.replace(/\/$/, '');
  if (import.meta.env.DEV) return 'http://localhost:4000';
  return 'https://studio-api.aifluens.com';
}

export function getStudioHomeUrl(): string {
  return `${getStudioAppUrl()}/home`;
}

/** Deep-link into Studio home with the certificate unlock/mint modal open. */
export function getStudioCertificateClaimUrl(projectId?: number): string {
  const params = new URLSearchParams({ claim: 'certificate' });
  if (projectId != null) {
    params.set('project_id', String(projectId));
  }
  return `${getStudioHomeUrl()}?${params.toString()}`;
}

/** Cross-origin session handoff after Academy provisions the workspace. */
export function getStudioHandoffUrl(handoffToken: string): string {
  const base = getStudioAppUrl();
  const params = new URLSearchParams({ handoff: handoffToken });
  return `${base}/auth/callback?${params.toString()}`;
}
